export default function GridModalHeader({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="text-[15px] font-pretendard flex justify-between items-center text-muted-foreground border-b pb-3 mb-3">
      {children}
    </div>
  );
}
